import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface Props {
  isOpen: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
}

export const ModalWithReact: React.FC<Props> = ({ isOpen, title, onClose, children }) => {
  const [show, setShow] = useState(false)

  // fade 動畫
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => setShow(true), 10)
      return () => clearTimeout(timer)
    } else {
      setShow(false)
    }
  }, [isOpen])

  if (!isOpen && !show) return null

  return ReactDOM.createPortal(
    <dialog
      className={`modal fade ${show ? 'show' : ''}`}
      tabIndex={-1}
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', transition: 'opacity 0.3s' }}>
      <html className="modal-dialog modal-dialog-centered" lang="zh-Hant-TW">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </html>
    </dialog>,
    document.body
  )
}
